import { render } from "./page-content.vue?vue&type=template&id=b5ecd796&scoped=true&ts=true"
import script from "./page-content.vue?vue&type=script&lang=ts"
export * from "./page-content.vue?vue&type=script&lang=ts"

import "./page-content.vue?vue&type=style&index=0&id=b5ecd796&scoped=true&lang=less"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5ecd796"]])

export default __exports__